import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import {
    Container, Button, Accordion, AccordionDetails, AccordionSummary, Skeleton, Typography, TextField,
} from '@mui/material';
import {useCatch, useEffectAsync} from '../../reactHelper';
import {useTranslation} from '../../common/components/LocalizationProvider';
import PageLayout from '../../common/components/PageLayout';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(2),
    },
    buttons: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-evenly',
        '& > *': {
            flexBasis: '33%',
        },
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
}));

const EditItemView = ({
                          children, endpoint, item, setItem, defaultItem, validate, onItemSaved, menu, breadcrumbs,
                      }) => {
    const navigate = useNavigate();
    const classes = useStyles();
    const t = useTranslation();

    const {id} = useParams();

    useEffectAsync(async () => {
        if (!item) {
            if (id) {
                const response = await fetch(`/api/${endpoint}/${id}`);
                if (response.ok) {
                    setItem(await response.json());
                } else {
                    throw Error(await response.text());
                }
            } else {
                setItem(defaultItem || {});
            }
        }
    }, [id, item, defaultItem]);

    const handleSave = useCatch(async () => {
        let url = `/api/${endpoint}`;
        if (id) {
            url += `/${id}`;
            // console.log("URL: " + url);
            // console.log("ITEM: " + JSON.stringify(item))
        }

        const response = await fetch(url, {
            method: !id ? 'POST' : 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(item),
        });

        if (response.ok) {
            // console.log("RES: " + JSON.stringify(response.ok));
            if (onItemSaved) {

                // console.log("onItemSaved");
                onItemSaved(await response.json());
            }

            // console.log("no onItemSaved");
            navigate(-1);
        } else {
            throw Error(await response.text());
        }
    });

    return (
        <PageLayout menu={menu} breadcrumbs={breadcrumbs}>
            <Container maxWidth="md" className={classes.container}>
                {item ? children : (
                    <Accordion defaultExpanded>
                        <AccordionSummary>
                            <Typography variant="subtitle1">
                                <Skeleton width="10em"/>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {[...Array(3)].map((_, i) => (
                                <Skeleton key={-i} width="100%">
                                    <TextField/>
                                </Skeleton>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                )}
                <div className={classes.buttons}>
                    <Button
                        type="button"
                        color="success"
                        variant="outlined"
                        onClick={() => navigate(-1)}
                        disabled={!item}
                    >
                        {t('sharedCancel')}
                    </Button>
                    <Button
                        type="button"
                        color="success"
                        variant="contained"
                        onClick={handleSave}
                        disabled={!item || !validate()}
                    >
                        {t('sharedSave')}
                    </Button>
                </div>
            </Container>
        </PageLayout>
    );
};

export default EditItemView;
